module.exports = __webpack_public_path__ + "static/img/open-icon.3700c41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/open-icon.png
// module id = ti/L
// module chunks = 1